import { render, staticRenderFns } from "./VouchCategory.vue?vue&type=template&id=66861d24"
import script from "./VouchCategory.vue?vue&type=script&lang=js"
export * from "./VouchCategory.vue?vue&type=script&lang=js"
import style0 from "./VouchCategory.vue?vue&type=style&index=0&id=66861d24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports